import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionSummary } from "@mui/material";
import Accordion, { AccordionProps } from "@mui/material/Accordion";
import { ReactNode, useEffect, useState } from "react";
import CloseIcon from "../../../assets/images/icons/CloseIcon";

type BriaAccordionProps = {
	accordionTitle: ReactNode;
	titleClass?: string;
	primaryButton?: ReactNode;
	useSecondaryIcons?: boolean;
	onChange?: ((expanded: boolean) => void) | ((event: React.SyntheticEvent, isExpanded: boolean) => void);
} & Omit<AccordionProps, "onChange">;

const BriaAccordion = ({
	accordionTitle,
	titleClass,
	useSecondaryIcons = false,
	children,
	expanded,
	onChange,
	...rest
}: BriaAccordionProps) => {
	const [localExpanded, setLocalExpanded] = useState(expanded);

	useEffect(() => {
		setLocalExpanded(expanded);
	}, [expanded]);

	const getExpandIcon = () => {
		if (useSecondaryIcons) {
			return localExpanded ? <CloseIcon /> : <AddIcon />;
		}
		return <ExpandMoreIcon />;
	};

	const handleChange = (event: React.SyntheticEvent, isExpanded: boolean) => {
		if (onChange) {
			if (onChange.length === 1) {
				(onChange as (expanded: boolean) => void)(isExpanded);
			} else {
				(onChange as (event: React.SyntheticEvent, isExpanded: boolean) => void)(event, isExpanded);
			}
		} else {
			setLocalExpanded(isExpanded);
		}
	};

	return (
		<Accordion {...rest} disableGutters elevation={0} square expanded={localExpanded} onChange={handleChange}>
			<AccordionSummary className={titleClass} expandIcon={getExpandIcon()}>
				{accordionTitle}
			</AccordionSummary>
			{children}
		</Accordion>
	);
};

export default BriaAccordion;
